import { Component } from '@angular/core';
import { Service } from './service';
import { MatRadioChange } from '@angular/material/radio';
import { Observable } from 'rxjs/internal/Observable';
import{Router, NavigationEnd} from '@angular/router';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Tax and Estate Planning';
  isShown:boolean=false;

  constructor( public quiz: Service, public router: Router){
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', 'UA-158176022-6', {'page_path': event.urlAfterRedirects});

      }
    })
  }


}
